var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * RotateHorizontal component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconRotateHorizontal extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.51273 8.49793C8.58081 8.90651 8.30479 9.29292 7.89621 9.36101C7.43428 9.43799 6.79445 9.56449 6.11239 9.74934C5.71259 9.85769 5.30067 9.62143 5.19232 9.22163C5.08397 8.82184 5.32023 8.40991 5.72002 8.30156C6.46031 8.10093 7.15026 7.96463 7.64964 7.88141C8.05822 7.81333 8.44464 8.08935 8.51273 8.49793Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.41513 9.92463C3.66658 10.2538 3.60359 10.7245 3.27443 10.9759C2.78354 11.3509 2.60547 11.6929 2.60547 12.0038C2.60547 12.3073 2.77262 12.6587 3.27874 13.0512C3.60606 13.3051 3.66564 13.7762 3.41181 14.1035C3.15798 14.4308 2.68686 14.4904 2.35953 14.2366C1.65659 13.6915 1.10547 12.95 1.10547 12.0038C1.10547 11.029 1.69183 10.2973 2.36385 9.78393C2.69301 9.53248 3.16368 9.59547 3.41513 9.92463Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.0015 1.10547C12.4157 1.10547 12.7515 1.44126 12.7515 1.85547V15.0215C14.6342 14.9576 16.7425 14.6583 18.4337 14.129C19.3976 13.8274 20.1768 13.466 20.6995 13.0674C21.2227 12.6684 21.395 12.3106 21.395 12.0029C21.395 11.7431 21.2741 11.4688 20.9517 11.1654C20.6227 10.8557 20.1352 10.5682 19.5436 10.3133C18.8631 10.02 18.1057 9.79533 17.4235 9.63049L18.0403 11.1574C18.1954 11.5415 18.0098 11.9786 17.6258 12.1337C17.2417 12.2889 16.8046 12.1033 16.6494 11.7192L15.5107 8.90019C15.3905 8.60264 15.4729 8.26158 15.7157 8.05177L18.0294 6.05263C18.3429 5.78182 18.8165 5.81636 19.0873 6.12978C19.3581 6.4432 19.3236 6.91682 19.0101 7.18763L17.8496 8.19041C18.5768 8.36917 19.3889 8.61327 20.1372 8.93572C20.8069 9.22433 21.4717 9.59491 21.9798 10.0731C22.4943 10.5574 22.895 11.2005 22.895 12.0029C22.895 12.9633 22.3276 13.7123 21.6091 14.2601C20.8901 14.8084 19.9256 15.2339 18.8817 15.5606C17.023 16.1423 14.7559 16.4583 12.7515 16.5223V22.1455C12.7515 22.5597 12.4157 22.8955 12.0015 22.8955C11.5873 22.8955 11.2515 22.5597 11.2515 22.1455V15.8318C11.2505 15.8162 11.25 15.8004 11.25 15.7845C11.25 15.7687 11.2505 15.7529 11.2515 15.7373V1.85547C11.2515 1.44126 11.5873 1.10547 12.0015 1.10547Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.18884 14.8263C5.29405 14.4257 5.70411 14.1862 6.10474 14.2914C6.83578 14.4833 7.94218 14.7386 8.64992 14.8023C9.06247 14.8393 9.36685 15.2038 9.32976 15.6164C9.29268 16.0289 8.92818 16.3333 8.51563 16.2962C7.67106 16.2203 6.45771 15.9349 5.72376 15.7422C5.32313 15.637 5.08364 15.2269 5.18884 14.8263Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconRotateHorizontal.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconRotateHorizontal.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconRotateHorizontal.prototype, "size", void 0);
if (customElements.get('cat-icon-rotate-horizontal') === undefined) {
    customElements.define('cat-icon-rotate-horizontal', BlocksIconRotateHorizontal);
}
